import BackLink from "../../reuseable/BackLink";
import { Button } from "../../reuseableComp.tsx/Button";
import {
  Input,
  InputGroupContainer,
  Label,
} from "../../reuseableComp.tsx/EffectInput";
import {
  ButtonArea,
  CenteredContent,
  CenteredObject,
  MainWrapper,
  TextArea,
  TextPtag,
} from "../Signup/style";

const Fullname = () => {
  return (
    <>
      <MainWrapper>
        <BackLink path="/" />
        <CenteredObject>
          <CenteredContent>
            <TextArea>
              <h2>Enter Username</h2>
            </TextArea>
            <TextPtag>
              <p>Enter your unique Username!</p>
            </TextPtag>

            <InputGroupContainer>
              <Input type="text" required autoComplete="off" id="name" />
              <Label htmlFor="name">First Name (required)</Label>
            </InputGroupContainer>

            <InputGroupContainer>
              <Input type="text" required autoComplete="off" id="name" />
              <Label htmlFor="name">Surnname (required)</Label>
            </InputGroupContainer>

            <ButtonArea>
              <Button>Continue</Button>
            </ButtonArea>
          </CenteredContent>
        </CenteredObject>
      </MainWrapper>
    </>
  );
};

export default Fullname;
